import { ParentsUIProvider } from "./ParentsUIContext";
import { ParentsCard } from "./ParentsCard";

export function ParentsPage({
  receipentType,
  setReceipentIds
}) {
  return (
    <ParentsUIProvider>
      <ParentsCard
        receipentType={receipentType}
        setReceipentIds={setReceipentIds}
      />
    </ParentsUIProvider>
 );
}